module.exports = __webpack_public_path__ + "img/foodette.d349443d.png";